module.exports = __webpack_public_path__ + "assets/img/5cde1e28e6c734895ea804aeaf7fb224.png";